import { render } from "./PriceBuySell.vue?vue&type=template&id=8da02bf4"
import script from "./PriceBuySell.vue?vue&type=script&lang=js"
export * from "./PriceBuySell.vue?vue&type=script&lang=js"
script.render = render

export default script